import React from "react";

/** Bar-chart glyph for the "Mijozlar analitikasi" sidebar item. */
const Analytics = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 3v17a1 1 0 0 0 1 1h17" />
      <rect x="7" y="12" width="3" height="5" rx="0.5" />
      <rect x="12.5" y="8" width="3" height="9" rx="0.5" />
      <rect x="18" y="5" width="3" height="12" rx="0.5" />
    </svg>
  );
};

export default Analytics;
